



































import BackIcon from '@icons/ArrowLeftThick'
import SoundIcon from '@icons/VolumeHigh'
import MuteIcon from '@icons/VolumeOff'
import Board from './Board'
import MessageBox from './MessageBox'
import Button from './Button'
import Moves from './Moves'
import i18n from '../i18n'
import * as sound from '../sound.coffee'

export default
  props: ['user', 'level', 'guide', 'show_moves']
  data: -> {
    msg: null
    msg_key: 0
    undo_enabled: false
    undo: ->
    muted: sound.is_muted()
    sound_supported: sound.is_supported()
    moves: ''
    entered_moves: ''
    i18n
  }
  mounted: -> window.scrollTo 0, 0
  computed:
    level_title: ->
      mode = i18n.t[@level]
      i18n.expand('mode', {mode})
  methods:
    show_message: (params) ->
      @msg_key++
      @msg = params
    set_undo_btn: (e) ->
      @undo_enabled = e.enabled
      @undo = e.undo
    mute: ->
      @muted = not @muted
      sound.mute(@muted)
    add_move: (move) -> @moves += move
    undo_move: -> @moves = @moves.substr(0, @moves.length-2)

  components: {
    BackIcon
    SoundIcon
    MuteIcon
    Board
    MessageBox
    Button
    Moves
  }
